import React, { useEffect, useState } from 'react';
import { downloadInstituicaoModelCSV, findInstituicaoAll, saveMasterInstituicao } from './api-instituicao';
import { errorMessage } from '../../util/ConfirmAlertUtil';
import Container from '../UI/Container';
import { Grid, Menu, MenuItem, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import InstituicaoTable from './InstituicaoTable';
import InstituicaoForm from './InstituicaoForm';
import { toast } from 'react-toastify';
import MenuIcon from '@mui/icons-material/Menu';
import { Link } from 'react-router-dom';

const useStyles = makeStyles({
    paper: {
        padding: '20px',
    },
    title: {
        marginBottom: '20px'
    },
    cursorLink: {
        cursor: 'pointer'
    }
});

const InstituicaoContainer = () => {
    const classes = useStyles();
    const [pageInstituicoes, setPageInstituicoes] = useState({
        content: [],
        size: 0,
        number: 0,
        totalElements: 0
    });
    const [instituicao, setInstituicao] = useState(null);
    const size = 10
    const [isLoading, setIsLoading] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);

    useEffect(() => {
        fetchDataInstituicao(0);
        // eslint-disable-next-line
    }, []);

    const fetchDataInstituicao = (newPage) => {
        setIsLoading(true);
        findInstituicaoAll(newPage, size).then((data) => {
            if (data) {
                if (data.error) {
                    errorMessage(data.message);
                } else {
                    setPageInstituicoes(data);
                }
            }
            setIsLoading(false);
        })
    }

    const handleChangePage = (event, newPage) => {
        fetchDataInstituicao(newPage);
    };

    const clickSubmit = (event) => {
        event.preventDefault();
        const eNovo = instituicao.eNovo;
        saveMasterInstituicao(instituicao).then(data => {
            if (data) {
                if (data.error) {
                    errorMessage(data.message);
                } else {
                    toast.success("Salvo com sucesso.", {
                        position: "bottom-left"
                    });
                    if (eNovo) {
                        setPageInstituicoes((prevState) => ({
                            ...prevState,
                            content: [data, ...prevState.content]
                        }));
                    } else {
                        setPageInstituicoes((prevState) => ({
                            ...prevState,
                            content: prevState.content.map((ps) => {
                                if (ps.codigo === data.codigo) {
                                    return data;
                                } else {
                                    return ps;
                                }
                            })
                        }))
                    }
                    setInstituicao(data);
                }
            }

        })
    }

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleDownloadModeloInstituicao = () => {
        downloadInstituicaoModelCSV().then((data) => {
            if (data) {
                if (data.error) {
                    errorMessage(data.message);
                } else {
                    var file = new Blob([data], { type: 'application/csv' });
                    var link = document.createElement('a');
                    link.href = URL.createObjectURL(file);
                    var fileName = "modelo_instituicao.csv";
                    link.download = fileName;
                    link.click();
                    // window.open(fileURL);
                }

            }
        })
    }

    return (
        <Container>
            <Grid container justifyContent="space-between">
                <Grid size={3}>
                    <Typography className={classes.title} variant="h6">
                        Instituição
                    </Typography>
                </Grid>
                <Grid>
                    <MenuIcon
                        className={classes.cursorLink}
                        onClick={(event) => handleMenuClick(event)}
                        color="secondary"
                    />
                    <Menu
                        id="simple-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleMenuClose}
                    >
                        <MenuItem
                            onClick={handleDownloadModeloInstituicao}
                        >
                            Download modelo CSV importar instituições
                        </MenuItem>
                        <MenuItem component={Link}
                            to={{ pathname: '/instituicao-import' }}>
                            Importar CSV
                        </MenuItem>


                    </Menu>
                </Grid>
            </Grid>
            {instituicao ?
                <InstituicaoForm
                    instituicao={instituicao}
                    setInstituicao={setInstituicao}
                    clickSubmit={clickSubmit}
                />
                :
                <InstituicaoTable
                    pageInstituicoes={pageInstituicoes}
                    handleChangePage={handleChangePage}
                    setInstituicao={setInstituicao}
                    isLoading={isLoading}
                />
            }
        </Container>
    );
}

export default InstituicaoContainer;